import { IFormEditor, IFormEditorDataSource, IFormEditorVm } from "../../../models/response/form/IFormEditor";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objFormEditorDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IFormEditor[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IFormEditorVm[],
    LOAD_COSO_ERROR: "",
    LOAD_TRUONG_START: 0,
    LOAD_TRUONG_SUCCESS: [] as IFormEditorVm[],
    LOAD_TRUONG_ERROR: "",
    LOAD_DATASOURCE_START: 0,
    LOAD_DATASOURCE_SUCCESS: [] as IFormEditorDataSource[],
    LOAD_DATASOURCE_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFormEditor | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFormEditor,
    SAVE_SUCESS: {} as IFormEditor,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};
export const eFormEditorActionTypeIds = generateActionTypeIds(objFormEditorDefine, "FORM_EDITOR")
export type IFormEditorActionTypes = IGenericActionType<typeof objFormEditorDefine, "FORM_EDITOR">
